<template >
  <div class="justify-content-between align-items-center content-sidebar px-1 py-1">
    <hr>
        <b-form>
            <b-row>

                <b-col
                    cols="12"
                    class="mb-2"
                >
                    <h5 class="mb-0">
                        EDITAR OPERADOR
                    </h5>
                </b-col>

                <b-col md="12">
                    <b-form-group
                    label="Nome Completo"
                    label-for="name"
                    invalid-feedback="Campo obrigatório"
                    >
                    <b-form-input
                    id="name"
                    v-model="name"
                    placeholder="Digite aqui"
                    :state="nomeState"
                    />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group
                    label="Empresa"
                    label-for="empresa"
                    invalid-feedback="Campo obrigatório"
                    >
                    <b-form-input
                    id="empresa"
                    v-model="empresa"
                    placeholder="Digite aqui"
                    :state="empresaState"
                    />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group
                    label="Matrícula"
                    label-for="matricula"
                    :invalid-feedback="matriculaInvalidaState ? 'Matrícula já existente':'Campo obrigatório'"
                    >
                    <b-form-input
                    id="matricula"
                    v-model="matricula"
                    placeholder="Digite aqui"
                    :state="matriculaState"
                    />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group
                    label="Centro de Trabalho"
                    label-for="workcenter"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="workcenter"
                        :options="listagemWorkcenters"
                      />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <b-button v-if="!sendingForm"
                        variant="primary"
                        class="form-control"
                        @click="updateOperator(currentWorkcenterId)"
                        >
                        Salvar
                        </b-button>

                    <b-button v-if="sendingForm"
                        variant="primary"
                        disabled
                        class="form-control"
                    >
                        <b-spinner small />
                        Loading ...
                    </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { TheMask } from 'vue-the-mask'
import vSelect from 'vue-select'

import {
  BAvatar, BListGroup, BListGroupItem, BCardText, BForm, BFormGroup, BFormInput, BFormSelect, BButton, BSpinner, BRow, BCol, BFormTextarea,
} from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
    BListGroup,
    BListGroupItem,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BSpinner,
    BRow,
    BCol,
    BFormTextarea,
    TheMask,
    flatPickr,
    ToastificationContent,
    vSelect
  },
  directives: {
    Ripple,
  },
  props:{
    currentWorkcenterId: {
      type: String,
    },
    contextoList:{
      type: Object
    },
    listagemOperadores:{
      type: Object
    },
    listagemWorkcenters: {
      default: [],
      type: Array,
    },
  },
  watch:{
    contextoList(){
      this.name = this.contextoList[0].name
      this.empresa = this.contextoList[0].company_code
      this.matricula = this.contextoList[0].employee_id
      this.idOperator = this.contextoList[0].id
      this.workcenter = this.listagemWorkcenters.filter(item => item.value == this.contextoList[0].workcenter_id)[0]
      this.validaCampos()
    }
  },
  data() {
    return {
      name: '',
      empresa: '',
      matricula: '',
      sendingForm: false,
      data: [],
      idOperator:'',
      nomeState: null,
      empresaState:null,
      matriculaState:null,
      matriculaInvalidaState:false,
      workcenter: ''
    }
  },
  methods: {
    validaCampos(){
      let qtdPalavras = this.name.split(" ").filter(item => item != "")
      this.nomeState = this.name && qtdPalavras.length >= 2  ? null : false
      this.empresaState = this.empresa ? null : false
      this.matriculaState = this.matricula && !this.validaMatricula() ? null: false 
      this.matriculaInvalidaState = this.validaMatricula()
    },
    validaMatricula(){

      let listagemValidação = []
      if(this.matricula == this.contextoList[0].employee_id && this.empresa == this.contextoList[0].company_code){
        return false
      }
      else {
        
        this.listagemOperadores.map(item => { 
            if(item.company_code == this.empresa && item.employee_id == this.matricula){
              listagemValidação.push('false')
            }
            else{
              listagemValidação.push('true')
            }
        })
        return listagemValidação.includes('false')
      }

    },
    updateOperator(id){
        this.validaCampos()
        if( this.nomeState != false && this.matriculaState != false && this.empresaState != false){
          this.sendingForm = true
          this.$http.put(`/api/operators/${id}`,
          {name: this.name, 
          company: this.empresa,
          employee_id: this.matricula,
          id: this.idOperator,
          workcenter_id: this.workcenter.value
          }).then(res => { 
                  this.sendingForm = false
                  this.$emit('refetch-data')
                  this.$emit('show-message')
              })
              .catch((error) => {
                  this.sendingForm = false
                  this.showToast('Error!', 'FrownIcon', error.response.data.message, 'danger')
              })
        }
    },
    showToast(title, icon, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: icon,
          text: text,
          variant,
        },
      })
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.form-control.is-invalid{
  background-image: none !important;
}
</style>